import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: "Geograph";
        src: url("/fonts/Geograph-Medium.otf") format("otf");
      }
      `}
  />
);

export default Fonts;
